const timer = {"time": 0, "s": 0, "ms": 0}
import Yaafloop from "yaafloop"
Yaafloop(function(delta) {
    timer.time += delta.s
    timer.s += delta.s
    timer.ms += delta.ms
})

export default timer
